
import omit from 'lodash-es/omit';

import { AlertResponse } from '@shared/widgets/entities/alerts';

const OMIT_KEYS = [
  'flex_dates',
  'direct_only',
  'price_max'
];

export function isDifferentAlert(storageAlert: AlertResponse, searchAlert: AlertResponse): boolean {
  return !!storageAlert && !!searchAlert &&
    Object.keys(diff(omit(storageAlert, OMIT_KEYS), omit(searchAlert, OMIT_KEYS))).length > 0;
}

function diff(storageAlert: AlertResponse, searchAlert: AlertResponse): AlertResponse {
  if (!searchAlert || Object.prototype.toString.call(searchAlert) !== '[object Object]') {
    return storageAlert;
  }

  const diffs: AlertResponse = {} as AlertResponse;

  const match = (arr1, arr2): boolean => {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  };

  const compare = (item1, item2, key): AlertResponse => {
    const type1 = Object.prototype.toString.call(item1);
    const type2 = Object.prototype.toString.call(item2);

    if (type2 === '[object Undefined]') {
      diffs[key] = null;
      return;
    }

    if (type1 !== type2) {
      diffs[key] = item2;
      return;
    }

    if (type1 === '[object Object]') {
      const objDiff = diff(item1, item2);
      if (Object.keys(objDiff).length > 1) {
        diffs[key] = objDiff;
      }
      return;
    }

    if (type1 === '[object Array]') {
      if (!match(item1, item2)) {
        diffs[key] = item2;
      }
      return;
    }

    if (type1 === '[object Function]') {
      if (item1.toString() !== item2.toString()) {
        diffs[key] = item2;
      }
    } else {
      if (item1 !== item2) {
        diffs[key] = item2;
      }
    }
  };

  for (const key in storageAlert) {
    if (Object.prototype.hasOwnProperty.call(storageAlert, key)) {
      compare(storageAlert[key], searchAlert[key], key);
    }
  }

  for (const key in searchAlert) {
    if (Object.prototype.hasOwnProperty.call(storageAlert, key)) {
      if (!storageAlert[key] && storageAlert[key] !== searchAlert[key]) {
        diffs[key] = searchAlert[key];
      }
    }
  }
  return diffs;
}
